import { createGlobalStyle } from 'styled-components';

// Styles
import reset from '../../assets/styles/reset';

// Fonts and texts
import { proximaNova } from '../../assets/styles/font';
import { baseText } from '../../assets/styles/text';

// Global CSS
import global from '../../assets/styles/global';

export default createGlobalStyle`
	// Reset css
	${reset};
	
	// Fonts
	${proximaNova};
	
	html, body {
		${baseText};
	}
	
	html, html a {
		-webkit-font-smoothing: antialiased;
	    -moz-osx-font-smoothing: grayscale;
	    text-rendering: optimizeLegibility;
	}
	
	// Global elements style
	${global};
`;
